import { defineComponent as _defineComponent } from 'vue'
import VsButton from '@/components/vision/VsButton.vue'
import TagsDisplay from '@/components/common/tags/TagsDisplay.vue'
import { toRef, computed } from 'vue'
import { useGetJobTagsQuery } from '@/api/jobs'
import { useJobTagsStore } from '@/components/jobs/jobTagsStore'
import { useJobBottomSheetStatesStore } from '@/components/jobs/jobBottomSheetStatesStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'JobTagsDisplay',
  props: {
    jobId: null
  },
  setup(__props: any) {

const props = __props as {
  jobId?: string | null // Job UUID - If null, then we are creating new jobs
}


const jobIdRef = toRef(props, 'jobId')
const isNewJob = computed(() => !props.jobId)

const { data: tags, isFetched } = useGetJobTagsQuery(jobIdRef)

const jobTagsStore = useJobTagsStore()
const jobBottomSheetStatesStore = useJobBottomSheetStatesStore()

const displayTags = computed(() => {
  if (props.jobId) {
    return tags.value || []
  }
  return jobTagsStore.draftTags
})

const handleClickEditTagsButton = () => {
  jobBottomSheetStatesStore.setJobBottomSheetStates({
    isTagBottomSheetVisible: true,
  })
}

return { __sfc: true,props, jobIdRef, isNewJob, tags, isFetched, jobTagsStore, jobBottomSheetStatesStore, displayTags, handleClickEditTagsButton, VsButton, TagsDisplay }
}

})